import * as React from 'react'

import { observer } from 'mobx-react'

import * as styles from './index.vanilla.css'

interface Props {
  src: string
}

const PDF = ({ src }: Props) => {
  return <iframe src={src} className={styles.viewer} />
}

export default observer(PDF)
